// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1018":"d338e520","3083":"d338e520","6149":"d338e520","8864":"d338e520","9628":"ffe73276"}[chunkId] + ".chunk.css";
};